import './Resume.css';
import { useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import profileImage from '../JASMIN.png';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaDownload, FaSearchPlus, FaSearchMinus, FaUniversity } from 'react-icons/fa';

function Resume() {
  const resumeRef = useRef();
  const [zoom, setZoom] = useState(1);

  const handleDownloadPDF = async () => {
    const element = resumeRef.current;
    const prevTransform = element.style.transform;
    element.style.transform = 'scale(1)';
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      width: element.scrollWidth,
      height: element.scrollHeight,
    });
    element.style.transform = prevTransform;
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save('Jasmin_Meghan_Malolos_Resume.pdf');
  };

  const zoomIn = () => setZoom(prev => Math.min(prev + 0.15, 2));
  const zoomOut = () => setZoom(prev => Math.max(prev - 0.15, 0.4));

  return (
    <div className="resume-page">
      {/* CONTROLS - upper right */}
      <div className="resume-controls">
        <button className="zoom-btn" onClick={zoomOut} title="Zoom Out">
          <FaSearchMinus />
        </button>
        <span className="zoom-level">{Math.round(zoom * 100)}%</span>
        <button className="zoom-btn" onClick={zoomIn} title="Zoom In">
          <FaSearchPlus />
        </button>
        <button className="download-btn" onClick={handleDownloadPDF}>
          <FaDownload /> Download PDF
        </button>
      </div>

      <div className="resume-scroll-area">
        <div
          className="resume-wrapper"
          ref={resumeRef}
          style={{ transform: `scale(${zoom})`, transformOrigin: 'top center' }}
        >
          {/* ===== HEADER ===== */}
          <div className="resume-header">
            <div className="header-accent"></div>
            <div className="header-content">
              <div className="header-photo-area">
                <div className="photo-ring">
                  <img src={profileImage} alt="Jasmin Meghan R. Malolos" className="resume-photo" />
                </div>
              </div>
              <div className="header-text">
                <h1 className="resume-name">JASMIN MEGHAN<br />MALOLOS</h1>
                <p className="resume-role">BS COMPUTER ENGINEER</p>
              </div>
            </div>
            <div className="contact-bar">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <span>09214192040</span>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <span>malolos.jasminmeghan@gmail.com</span>
              </div>
              <div className="contact-item">
                <FaUniversity className="contact-icon" />
                <span>FAITH COLLEGES</span>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>San Vicente, Sto Tomas Batangas</span>
              </div>
            </div>
          </div>

          {/* ===== BODY ===== */}
          <div className="resume-body">
            {/* LEFT COLUMN */}
            <div className="resume-col-left">
              {/* Objective moved to right column */}

              <div className="body-section">
                <h3 className="section-heading">Education</h3>
                <div className="edu-item">
                  <p className="edu-degree">BS Computer Engineering</p>
                  <p className="edu-school">FAITH Colleges</p>
                  <p className="edu-year">2023 – Present</p>
                </div>
              </div>

              <div className="body-section">
                <h3 className="section-heading">Skills</h3>
                <div className="skills-tags">
                  <span className="skill-tag">Python</span>
                  <span className="skill-tag">C / C++</span>
                  <span className="skill-tag">Web Development</span>
                  <span className="skill-tag">Circuit Design & PCB</span>
                  <span className="skill-tag">Embedded Systems</span>
                  <span className="skill-tag">HDL / Verilog</span>
                  <span className="skill-tag">MATLAB</span>
                  <span className="skill-tag">Signal Processing</span>
                  <span className="skill-tag">Project Management</span>
                  <span className="skill-tag">Team Collaboration</span>
                </div>
              </div>

              <div className="body-section">
                <h3 className="section-heading">Achievements</h3>
                <div className="achieve-list">
                  <div className="achieve-row">
                    <span className="achieve-label">With Honors</span>
                    <span className="achieve-info">Sto. Tomas North Central School, 2016–2017</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">With Honors</span>
                    <span className="achieve-info">San Pedro National High School, 2017–2021</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">With Honors</span>
                    <span className="achieve-info">FAITH Fidelis Senior High, 2021–2023</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">President's Lister</span>
                    <span className="achieve-info">FAITH Colleges, 2023</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">Dean's Lister</span>
                    <span className="achieve-info">FAITH Colleges, 2024–2026</span>
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT COLUMN */}
            <div className="resume-col-right">
              <div className="body-section">
                <h3 className="section-heading">Objective</h3>
                <p className="body-text">
                  A dedicated and driven BS Computer Engineering student at FAITH Colleges seeking opportunities to apply academic knowledge in real-world settings. Eager to contribute to innovative projects in software development, embedded systems, and digital design while continuously growing technical and professional skills.
                </p>
              </div>

              <div className="body-section">
                <h3 className="section-heading">Projects</h3>
                <div className="project-list">
                  <div className="project-row">
                    <span className="project-name">Snake & Ladder Game</span>
                    <span className="project-tag">CPE-CP1</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Sign Language Recognition System (Python)</span>
                    <span className="project-tag">CPE-CP2</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">3D Heat Conduction on Metal Plates (PDE)</span>
                    <span className="project-tag">CPE-MAT</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">MicroLab Inventory Management System</span>
                    <span className="project-tag">CPE-OOP</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Two-Digit Decimal Counter PCB Design</span>
                    <span className="project-tag">CPE-DES</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Voice-Controlled LED System (ESP32 + FFT)</span>
                    <span className="project-tag">ECE-DSP</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Graduate Tracer Study of CPE Graduates</span>
                    <span className="project-tag">Research</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Secure Digital Lock System (ABV Verification)</span>
                    <span className="project-tag">CPE-HDL</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Restaurant Web App</span>
                    <span className="project-tag">CPE-DS</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Smart Room Access & Status Indication</span>
                    <span className="project-tag">CPE-ES</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Sumo Bot</span>
                    <span className="project-tag">CPE-ES</span>
                  </div>
                  <div className="project-row">
                    <span className="project-name">Ambient Light-Based Smart Lighting System</span>
                    <span className="project-tag">CPE-FCS</span>
                  </div>
                </div>
              </div>

              <div className="body-section">
                <h3 className="section-heading">Seminars / Trainings</h3>
                <ul className="bullet-list">
                  <li>Arduino Workshop Part 1 & 2</li>
                  <li>HIV Awareness & Community Empowerment</li>
                  <li>Career Stories & Industry Insights</li>
                  <li>Bantay Kalikasan Seminar</li>
                  <li>Design of RISC-V Microprocessor</li>
                  <li>3rd Annual CIDR Conference</li>
                  <li>Building Intelligence: CPE meets Data Science</li>
                </ul>
              </div>

              <div className="body-section">
                <h3 className="section-heading">Leadership & Activities</h3>
                <div className="achieve-list">
                  <div className="achieve-row">
                    <span className="achieve-label">Year Level Rep</span>
                    <span className="achieve-info">Math Club, 2017–2018</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">Year Level Rep</span>
                    <span className="achieve-info">Filipino Club, 2018–2019</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">Year Level Rep</span>
                    <span className="achieve-info">MAPEH Club, 2019–2020</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">Media & Graphics Officer</span>
                    <span className="achieve-info">FAITH CpE Society, 2024–2025</span>
                  </div>
                  <div className="achieve-row">
                    <span className="achieve-label">Secretary</span>
                    <span className="achieve-info">FAITH CpE Society, 2025–2026</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resume;
